import Sidebar from "../components/Sidebar";
const DashboardLayout = ({ children, onLogout }) => {
  return (
    <div className="flex min-h-screen w-full bg-gray-100">     
      {/* Sidebar */}
      <div className="flex-shrink-0">
        <Sidebar onLogout={onLogout} />
      </div>
      {/* Page Content */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden"> 
        {/* Main Content Area */}
        <div className="flex-1 overflow-auto">
          {children}
        </div>

      </div>
    </div>
  );
};
export default DashboardLayout;